import React from 'react';
import { cn } from '../lib/utils';
import SponsorLogo from './SponsorLogo';

const VenueSignature = ({ className, labelClassName, logoClassName, label = 'Hosted at' }) => {
  return (
    <div
      className={cn(
        'inline-flex gap-3 items-center px-3 py-2 rounded-full text-white/90 whitespace-nowrap',
        className
      )}
    >
      <span
        className={cn(
          'text-[10px] font-medium uppercase tracking-[0.24em] text-white/55 whitespace-nowrap',
          labelClassName
        )}
      >
        {label}
      </span>
      <span aria-hidden="true" className="w-px h-4 bg-white/12" />
      <SponsorLogo className={cn('w-24 h-6', logoClassName)} alt="Bozar" />
    </div>
  );
};

export default VenueSignature;
